import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { activityLogAPIResponse, activityLogInitialState, deviceHistoryResponse, getActivityLogPayload } from "../../components/profile/activityLog/activityLogModule";
import { ZenToast } from "zen-core-elements";


const initialState: activityLogInitialState = {
	Listcount: 0,
	activityLog: [],
	deviceHistory: null
}

export const getActivityLogsApi = createAsyncThunk("ActivityLogSlice/getActivityLog", ({ storeId, userId, payload }: getActivityLogPayload) => {
	const url = HttpRoutingService.replaceUrl(API?.getActivityLog, { storeId, userId })
	return HttpRoutingService?.getMethod<activityLogAPIResponse>(url, payload, "v1/")
})
export const getDeviceHistoryApi = createAsyncThunk("ActivityLogSlice/getDeviceHistoryApi", ({ storeId, userId }: { storeId: number, userId: number }) => {
	const url = HttpRoutingService.replaceUrl(API?.getDeviceHistory, { storeId, userId })
	return HttpRoutingService?.getMethod<deviceHistoryResponse>(url, null, "v1/")
})
const ActivityLogSlice = createSlice({
	name: "ActivityLogSlice",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getActivityLogsApi?.fulfilled, (state, action) => {
				const { payload: { offset } } = action?.meta?.arg
				if (offset > 0) {
					if (action?.payload?.userLoginDetails && action?.payload?.userLoginDetails?.rows?.length) {
						state.activityLog = [...state.activityLog, ...action?.payload?.userLoginDetails?.rows]
					}
				} else {
					state.activityLog = action?.payload?.userLoginDetails?.rows ?? []
				}
				state.Listcount = action?.payload?.userLoginDetails?.count || 0
			})
			.addCase(getActivityLogsApi?.rejected, () => {
				ZenToast({
					type: "error",
					message: "Failed to get the activity logs"
				})
			})
			.addCase(getDeviceHistoryApi?.fulfilled, (state, action) => {
				state.deviceHistory = action?.payload
			})
	}
})

export default ActivityLogSlice?.reducer